import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import DesktopImage from '../../../assests/desktopapplication.jpeg';

const Desktopapplication= () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Desktop Application Development"
          src={DesktopImage}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Desktop Application Development
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Cross-Platform Desktop Apps:</strong> Building apps that run on Windows, macOS, and Linux using Electron or Java.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Native Desktop Apps:</strong> Developing platform-specific apps for Windows or macOS.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>UI/UX Design for Desktop Apps:</strong> Designing user-friendly interfaces for desktop applications.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Integration with Cloud Services:</strong> Connecting desktop apps to cloud services for data storage and synchronization.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Security Features:</strong> Implementing encryption, authentication, and other security measures.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Automation Tools:</strong> Developing desktop apps for task automation and process optimization.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Database Integration:</strong> Integrating desktop apps with local or cloud databases.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Performance Optimization:</strong> Ensuring efficient use of system resources and quick response times.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Desktopapplication;
